<div class="flex flex-row">
  <!-- <button [matMenuTriggerFor]="menu" #filterTrigger class="flex justify-between items-center filter-class mat-body-2 fw-700 w-240 white-bg">
    <span class="mr-auto">{{ (filterType ? filterType : 'INSPIRATION_LOUNGE.LOUNGE.FILTER') | transloco | uppercase }}</span>
    <mat-icon svgIcon="expand_more" class="ml-auto mr-8 mt-4"></mat-icon>
  </button> -->
  <mat-menu #menu="matMenu" class="justify-between items-center pl-24 pr-24 pt-16 pb-16 absolute-dropdown">
    <div class="flex flex-col overflow-class pr-10">
      <div *ngFor="let filterGroupItem of filterGroups; let i = index" class="flex flex-col">
        <div *ngFor="let filterItem of filterGroupItem.items" class="flex flex-row items-center cursor-pointer w-100-percent p-6"
            (click)="selectFilterTypes(filterItem, $event)" >
          <mat-icon [svgIcon]="filterItem.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon icon-md"></mat-icon>
          <span class="mat-subtitle-2 fw-500 ml-6 mr-auto mb-0 primary-fg">
              {{filterItem?.displayName ? filterItem.displayName : filterItem.name}}
            </span>
          <span class="primary-fg"> {{filterItem.count }}</span>
        </div>
        <mat-divider *ngIf="i < filterGroups.length - 1" class="dropdown-divider mt-6 mb-10"></mat-divider>
      </div>
      <span class="flex-auto mb-10"></span>
    </div>
    <mat-divider class="dropdown-divider mt-8 mb-16"></mat-divider>
    <div class="flex flex-row justify-between items-center" dir="rtl">
      <button class="basic-button mat-subtitle-2 fw-700 mb-0 cursor-pointer pr-2 h-auto" (click)="applyFilter()">
        {{ 'BUTTONS.APPLY' | transloco }}
      </button>
      <button *ngIf="selectedItems?.length > 0" class="basic-button mat-subtitle-2 fw-500 mb-0 cursor-pointer pl-2 h-auto" (click)="resetFilter()">
        {{ 'BUTTONS.RESET' | transloco }}
      </button>
    </div>
  </mat-menu>
  <div *ngIf="inspirationLoungeFilter" class="flex flex-row flex-wrap">
    <button *ngFor="let filterItem of filterData" (click)="applyFilterData(filterItem.tags)" [ngClass]="{'active': filterItem.tags === activeLink}" class="white mat-body fw-600 ml-24 mr-24 pl-24 pr-24">{{filterItem.tags}}</button>
  </div>
</div>

<div class="flex flex-row">
  <div class="flex flex-row flex-wrap">
    <span *ngFor="let filterItem of selectedItems" class="flex items-center item btn-font-rounded mr-24 mt-24">
      {{filterItem?.displayName ? filterItem.displayName : filterItem.name}}
      <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="filterItem.selected = false; applyFilter()"></mat-icon>
    </span>
    <span *ngIf="selectedItems?.length > 0" class="flex items-center mat-subtitle-2 fw-500 mb-0 cursor-pointer mt-24 warn-solid-fg" (click)="resetFilter()">
      {{ 'BUTTONS.CLEAR_ALL' | transloco }}
    </span>
  </div>
</div>
